<template>
  <section class="section">
    <Loader :isLoading="this.isLoading"></Loader>

    <div v-if="!isLoading" class="section">
      <div class="content">
        <div class="column is-8-desktop is-offset-2-desktop is-12-mobile">
          <markdown>{{ pageContent }}</markdown>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  /* Services */
  import Contentful from '@/services/Contentful'

  /* Components */
  import Loader from '@/components/General/Loader'

  export default {
    data () {
      return {
        pageContent: '',
        isLoading: true
      }
    },
    async mounted () {
      /* Get content */
      this.pageContent = (await Contentful.getAllEntriesByContentType('pageTeam')).data.items[0].fields.pageContent
      this.isLoading = false
      /* Scroll to top */
      window.scrollTo(0, 0)
    },
    components: {
      Loader
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Pages/Team.vue